import { Flex } from 'antd';
import styled, { css } from 'styled-components';

export const CardWrapper = styled.div<{
  $isrest: boolean;
  $isselected: boolean;
  $istoday: boolean;
}>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  cursor: pointer;
  border-radius: 8px;
  background: ${({ theme, $istoday }) => ($istoday ? theme.colors.green1 : theme.colors.white)};
  border: ${({ theme, $istoday }) =>
    $istoday ? `1px solid ${theme.colors.green4}` : `1px solid ${theme.colors.black4}`};

  ${({ $isselected }) =>
    $isselected &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.green6};
    `}
  &:hover {
    border: ${({ $isselected }) => ($isselected ? '2px solid' : '1px solid')};
    border-color: ${({ theme }) => theme.colors.green6};
  }
`;

export const ContentWrapper = styled(Flex)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;
  justify-content: space-between;
`;

export const DateWrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const WeekDay = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const DayNumber = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
